<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<p class="iim" style="text-align: center;margin-top:25px;margin-bottom:25px;"><img alt="" src="media/file0.png" style="width:4.6875in;height:7.15399in"/></p>
<p><em>Figure 1 – Western Missouri / Eastern Kansas</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?b871d340